import { useFetch } from "../lib/api";
import { MonthPicker } from "./DateField";

const RISK = {
  LOW: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  MEDIUM: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  HIGH: "bg-orange-500/10 text-orange-400 border-orange-500/20",
  BLOCK_DISBURSEMENT: "bg-rose-500/10 text-rose-400 border-rose-500/30 animate-pulse font-bold",
};

export const RiskBadge = ({ status, testid }) => (
  <span data-testid={testid || "vendor-risk-badge"}
    className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider ${RISK[status] || RISK.LOW}`}>
    {status?.replace("_", " ")}
  </span>
);

export const Pill = ({ tone = "slate", children, testid }) => {
  const t = {
    green: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
    red: "bg-rose-500/10 text-rose-400 border-rose-500/30",
    amber: "bg-amber-500/10 text-amber-400 border-amber-500/20",
    blue: "bg-cyan-500/10 text-cyan-400 border-cyan-500/20",
    slate: "bg-slate-500/10 text-slate-300 border-slate-500/20",
  }[tone];
  return <span data-testid={testid} className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider ${t}`}>{children}</span>;
};

export const PageHeader = ({ eyebrow, title, desc, children }) => (
  <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between mb-8 c-rise">
    <div>
      <div className="c-eyebrow mb-2">{eyebrow}</div>
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight" data-testid="page-title">{title}</h1>
      {desc && <p className="text-slate-400 text-sm mt-2 max-w-2xl">{desc}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const Empty = ({ text, testid = "empty-state" }) => (
  <div data-testid={testid} className="py-14 text-center text-sm text-slate-500 font-mono">{text}</div>
);

export function useVendors() {
  return useFetch("/vendors");
}

export const VendorMonthBar = ({ vendors, vendorId, setVendorId, month, setMonth, children }) => (
  <div className="c-surface p-4 flex flex-col sm:flex-row gap-3 sm:items-end mb-6 c-rise">
    <label className="grid gap-1.5 flex-1">
      <span className="text-xs text-slate-400">Vendor partner</span>
      <select className="c-input" value={vendorId} onChange={(e) => setVendorId(e.target.value)} data-testid="vendor-select">
        <option value="">Select vendor…</option>
        {(vendors || []).map((v) => <option key={v.id} value={v.id}>{v.vendor_name}</option>)}
      </select>
    </label>
    <label className="grid gap-1.5 sm:w-48">
      <span className="text-xs text-slate-400">Billing month</span>
      <MonthPicker value={month} onChange={setMonth} testid="month-input" className="" />
    </label>
    {children}
  </div>
);
